module.exports = __webpack_public_path__ + "static/media/tbbg.e685e2f2.jpg";